<resource-activity [resourceId]="(collection$ | async)?.id"
                   [resourceType]="resourceType"
                   [workspace]="workspace$ | async">
</resource-activity>
